RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.PrimaryNavigation = Marionette.LayoutView.extend({
        regions: {
            dataFreshness: '.x-data-freshness',
            companySetFilters: '.x-company-set-filters',
            datepicker: '.x-datepicker',
            title: '.x-title'
        },
        ui: {
            popovers: '[data-toggle="popover"]'
        },
        events: {
            'click #menu-toggle': 'onMenuToggleClick'
        },
        className: 'x-shell-section-header',
        template: '#shellPrimaryNavigationTemplate',

        onMenuToggleClick: function (e) {

            // todo: don't use global selectors, somehow (event?)
            e.preventDefault();
            $('#application').toggleClass('toggled');
            $('body').toggleClass('no-scroll');
        },

        onShow: function () {

            const me = this;

            me.showCompanySetFilters();
            me.showTimePeriod();
            me.showDataFreshness();
            me.showTitle();
        },

        onRender: function () {

            const me = this;
            me.ui.popovers.popover();
        },

        templateHelpers: function () {

            const me = this;
            let title = _.result(me.model.get('page'), 'name');
            let titleClassName = _.result(me.model.get('page'), 'className', '');

            // if the page name is a view, it will be rendered into the title region during onShow
            if (title && title.render) {

                title = '';
                titleClassName += ' complex-title x-primary-navigation-title';
            }

            return {
                title: title,
                titleClassName: titleClassName
            };
        },

        showTitle: function () {

            const me = this;
            const title = _.result(me.model.get('page'), 'name');

            if (title && title.render) {

                me.title.show(title);
            }
        },

        getTitle: function () {
            const me = this;

            if (me.title.currentView) {
                return me.title.currentView.getTitle();
            }
            return _.result(me.model.get('page'), 'name');
        },

        showCompanySetFilters: function () {

            const me = this;
            const state = RivalIQ.state;

            const data = {
                collection: state.companySets,
                model: state.view,
                filter: function (model) {
                    const me = this;
                    const hideShowOnlyCompany = !(model.id === state.companySets.onlyCompany && me.getOption('onlyCompanyDisabled'));
                    return hideShowOnlyCompany;
                }
            };

            // Add company set specific data passed into the model to the view attributes
            _.extend(data, me.model.get('components').companySets);
            me.companySetFilters.show(new views.CompanySetFilters(data));
        },

        getComponentTimePeriod: function () {
            const me = this;
            const components = me.model.get('components');
            let componentTimePeriod = components.timePeriod;

            // TODO stop sending garbage render calls at startup
            if (!componentTimePeriod.id && !componentTimePeriod.disabled) {
                componentTimePeriod = RivalIQ.state.view.get('timePeriod');
            }

            return componentTimePeriod;
        },

        showTimePeriod: function () {
            const me = this;

            me.datepicker.show(new views.TimePeriodPickerButton({
                model: me.getComponentTimePeriod(),
                dateRangeRestrictions: me.model.get('components').timePeriodDateRangeRestrictions,
                descriptionOverride: me.model.get('components').timePeriodDescription,
                displayStringOverride: me.model.get('components').timePeriodMessage
            }));
        },

        showDataFreshness: function () {
            const me = this;

            const components = me.model.get('components');
            const disabled = _.get(components, ['dataFreshness', 'disabled'], false);

            if (!disabled) {
                me.dataFreshness.show(new views.DataFreshness({
                    model: new Backbone.Model({
                        timePeriod: me.getComponentTimePeriod()
                    })
                }));
            }
        }
    });

});
